import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { Hero } from "../components/Section";

const LEAD = "How Syni.ai handles what you send us. Plain language, in line with the Kenya Data Protection Act, 2019.";

const SECTIONS = [
  {
    h: "1. Who we are",
    p: [
      "Syni.ai is a pan-African applied AI research and product studio headquartered at Riverside Square, Off Riverside Drive, Nairobi. For the purposes of the Data Protection Act, 2019, Syni.ai is the data controller for the information described on this page.",
    ],
  },
  {
    h: "2. What we collect",
    p: ["We collect only what you give us through the three forms on this site:"],
    list: [
      "Contact: your name, organisation, work email and message.",
      "Aky early access: organisation, country, your name, role, work email, sector, headcount and, if you add it, one sentence on where you want AI working first.",
      "Lead.ai nomination: the nominated executive's name, role, organisation, country and work email; the nominator's name, role and work email; the programme of interest and, if added, one sentence on the adoption decision.",
    ],
    after: [
      "When a form is submitted we also record the date and time, the browser type, and a one-way hash of the connection address, used only to limit automated submissions. The hash cannot be reversed to identify you.",
    ],
  },
  {
    h: "3. Why we collect it",
    list: [
      "To reply to you.",
      "To review applications for Aky early access and nominations to Lead.ai, and to contact the people named in them.",
      "To keep a record of who has written to us.",
    ],
    after: ["We do not use what you send for marketing. Nothing is sent to you beyond the reply, unless you ask for it."],
  },
  {
    h: "4. Lawful basis",
    p: [
      "We process this information on the basis of your consent, given when you submit a form, and our legitimate interest in responding to enquiries and running the programmes you apply or are nominated to.",
      "Where a nominator submits another person's details, the nominator confirms they are entitled to share them. We tell the nominated person where their details came from when we first contact them.",
    ],
  },
  {
    h: "5. Who sees it",
    p: [
      "Your information is seen by the Syni.ai team responsible for the form you used. It is stored with the providers that host this site and its database, and may be delivered to our inbox by an email delivery service. These providers process it only on our instruction.",
      "We do not sell it, rent it or share it with anyone else, except where the law requires.",
    ],
  },
  {
    h: "6. How long we keep it",
    p: [
      "We keep your information for as long as needed to respond to you and to administer the programme concerned, and after that only for as long as we have a reason to hold it. You may ask us to delete it at any time.",
    ],
  },
  {
    h: "7. Your rights",
    p: ["Under the Data Protection Act, 2019 you have the right to:"],
    list: [
      "be told how your information is used;",
      "access the information we hold about you;",
      "have inaccurate information corrected;",
      "have your information deleted;",
      "object to processing, or ask that it be restricted;",
      "withdraw consent at any time.",
    ],
    after: [
      "To exercise any of these, write to info@syni.ai or use the Contact page. We respond within the time the Act allows. You also have the right to lodge a complaint with the Office of the Data Protection Commissioner of Kenya.",
    ],
  },
  {
    h: "8. Cookies and analytics",
    p: [
      "This site sets no tracking cookies and runs no advertising or analytics scripts. Typefaces are loaded from Google Fonts, which records the technical request needed to serve them.",
    ],
  },
  {
    h: "9. Security",
    p: [
      "Information travels over an encrypted connection and is stored with access limited to the people who need it. No system is beyond failure. If we become aware of a breach affecting your information, we will notify you and the Commissioner as the Act requires.",
    ],
  },
  {
    h: "10. Changes",
    p: ["If this page changes, the date below changes with it."],
  },
];

export default function Privacy() {
  return (
    <>
      <Seo title="Privacy — Syni.ai" description={LEAD} path="/privacy" />
      <Hero title="Privacy" lead={LEAD} testId="privacy-hero" />
      <section className="section note-section" data-testid="privacy-body">
        <div className="container-syni">
          <div className="note-article note-blocks">
            {SECTIONS.map((s) => (
              <React.Fragment key={s.h}>
                <h2 className="note-h">{s.h}</h2>
                {(s.p || []).map((t) => (
                  <p key={t} className="body-copy">
                    {t}
                  </p>
                ))}
                {s.list ? (
                  <ul className="plain-list">
                    {s.list.map((t) => (
                      <li key={t}>{t}</li>
                    ))}
                  </ul>
                ) : null}
                {(s.after || []).map((t) => (
                  <p key={t} className="body-copy">
                    {t}
                  </p>
                ))}
              </React.Fragment>
            ))}
            <p className="mono-label" style={{ marginTop: 48 }} data-testid="privacy-updated">
              Last updated · October 2026
            </p>
            <div className="note-foot">
              <Link to="/contact" className="link-arrow" data-testid="privacy-contact-link">
                <span className="arr" aria-hidden="true">→</span> Contact
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
